var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebProcess01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#241c12;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.42,300.31c-3.95-9.52-6.56-19.03-7.91-28.68-1.19-9.72-1.73-16.49-1.36-20.62s1.26-11.11,2.41-20.67c2.92-18.98.58-37.87-7.18-56.6-2.61-6.3-7.5-8.05-14.67-5.27-6.62,2.74-7.91,8.76-3.96,18.28l9.29,22.44-40.03,16.58-10.9-26.31c-6.75-16.3-7.58-31.09-2.33-44.42,5.26-13.33,15.26-22.96,30.27-29.18,18.56-7.69,34.56-7.89,48.21-.49,13.59,7.23,23.92,19.4,31.01,36.51,5.28,12.75,6.46,34.77,3.69,65.98-.89,9.26-1.39,16.27-1.49,21.04-.44,9.45.74,23.71,5.29,34.69l-40.35,16.72ZM161.49,371.66l-19.73-47.62,49.55-20.53,19.73,47.62-49.55,20.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.72,136.16c-18.78,0-34.05-15.28-34.05-34.05s15.28-34.05,34.05-34.05,34.05,15.28,34.05,34.05-15.28,34.05-34.05,34.05ZM184.72,75.67c-14.57,0-26.43,11.86-26.43,26.43s11.86,26.43,26.43,26.43,26.43-11.86,26.43-26.43-11.86-26.43-26.43-26.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.91,356.23c-24.8,0-44.98-20.18-44.98-44.98s20.18-44.98,44.98-44.98,44.98,20.18,44.98,44.98-20.18,44.98-44.98,44.98ZM334.91,273.89c-20.6,0-37.36,16.76-37.36,37.36s16.76,37.36,37.36,37.36,37.36-16.76,37.36-37.36-16.76-37.36-37.36-37.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.62,366.91c-16.4,0-29.73-13.34-29.73-29.73s13.34-29.73,29.73-29.73,29.73,13.34,29.73,29.73-13.34,29.73-29.73,29.73ZM70.62,315.06c-12.19,0-22.11,9.92-22.11,22.11s9.92,22.11,22.11,22.11,22.11-9.92,22.11-22.11-9.92-22.11-22.11-22.11Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 253.48,
    y: 108.7,
    width: 7.62,
    height: 186.11,
    transform: "translate(-69.36 187.45) rotate(-35.59)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.06,
    y: 321.14,
    width: 198.35,
    height: 7.62,
    transform: "translate(-30.8 20.62) rotate(-5.6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.44,236.68l16.31-40.05,41.68,16.97-16.31,40.05-41.68-16.97ZM274.25,176.72l29.82-94.21,16.09-39.5,36.52,14.87-16.09,39.5-44.49,88.24-21.86-8.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebProcess01);
export default __webpack_public_path__ + "static/media/WebProcess-01.688dfd05088188d4fc616ae2e0c1ca0d.svg";
export { ForwardRef as ReactComponent };